import Modal from 'components/shared/Modal'

import './style.styl'

const WarningModal = ({ Service = 'Calendar', handleCloseModal, handleDisconnect }) => (
  <Modal onClose={handleCloseModal} isOpen style={{ content: { padding: 0, width: 450 }}}>
    <div className="settings-calendar-warning-modal-content">
      <div className="topper">
        <div className="header">Disconnect {Service} Account</div>
        <div className="copy">You’re about to disconnect your {Service} Account from Drift.</div>
        <div className="copy">
          This may change your messaging experience:
          <ul>
            <li>Your calendar will no longer be shared in conversations</li>
            <li>Meeting links you've shared will no longer work</li>
            <li>You will be unable to use Drift Sequences</li>
            <li>Your calendar will no longer be shared by playbooks</li>
          </ul>
          <div className="helptext">This will not affect any meetings you have already scheduled.</div>
        </div>
      </div>
      <div className="controls">
        <button className="tide-button tide-button--tertiary" onClick={handleCloseModal}>
          Cancel
        </button>
        <button className="tide-button tide-button--danger" onClick={handleDisconnect}>
          Disconnect
        </button>
      </div>
    </div>
  </Modal>
)

export default WarningModal



// WEBPACK FOOTER //
// ./src/scripts/components/settings/meetings/WarningModal/component.js